/** @format */

import {parseISO, startOfDay, isValid, subDays} from 'date-fns';

import {MediaplanType} from '../types';

const endMs = (end?: Date) => (end ? end.getTime() : Infinity);

/**
 * Берёт период, который покрывает "сегодня" (включительно) и среди таких периодов имеет самый поздний startOn.
 * При равенстве startOn предпочитает больший endOn (или открытый конец).
 */

const getCurrentMediaplan = (
  items: ReadonlyArray<MediaplanType>,
  today: Date,
): MediaplanType | undefined => {
  if (!items.length) {
    return;
  }

  const day = startOfDay(today);
  const yesterday = subDays(day, 1);

  const normalized = items
    .map(item => {
      const start = startOfDay(parseISO(item.startOn));
      const end = item.endOn ? startOfDay(parseISO(item.endOn)) : undefined;
      return {item, start, end};
    })
    .filter(x => isValid(x.start) && (!x.end || isValid(x.end)))
    // свежесть: позже start — выше; при равенстве — больше end (открытый конец = Infinity)
    .sort((a, b) => {
      const sDiff = b.start.getTime() - a.start.getTime();
      return sDiff !== 0 ? sDiff : endMs(b.end) - endMs(a.end);
    });

  // 1) покрывает "сегодня", но старт строго раньше сегодняшнего дня
  const todayPick = normalized.find(x => x.start < day && day.getTime() <= endMs(x.end));
  if (todayPick) {
    return todayPick.item;
  }

  // 2) иначе — покрывает "вчера"
  const yesterdayPick = normalized.find(
    x => x.start <= yesterday && yesterday.getTime() <= endMs(x.end),
  );
  return yesterdayPick?.item;
};

export {getCurrentMediaplan};
